<!-- 主播审核-->
<template>
  <div>
    <x-tabula
      ref="table"
      apiOrigin="PHP"
      :dataSource="dataSource"
      rowKey="apply_id"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptLen="4"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :addHandleParam="addHandleParam"
      :rowSelection="false"
    >
      <template slot="opt_action_t" slot-scope="{row}">
        <div style="color: #3fa9ff;cursor: pointer;" v-if="!row.check_status" @click="$refs.table.toEdit(row)">审核</div>
        <div style="color: #ccc;" v-else>审核</div>
      </template>
    </x-tabula>
  </div>
</template>

<script>
export default {
  name: 'anchorReview',
  data () {
    return {
      searchList: [
        { props: ['keywords'], placeholder: '用户昵称', options: [], inputType: 'input' },
        { props: ['user_type'], placeholder: '类型', options: [], inputType: 'select' },
        { props: ['status'], placeholder: '状态', options: [], inputType: 'select' }
      ],
      tableOptList: [],
      rowOptList: [
        { text: '审核', handle: (row) => this.$refs.table.toEdit(row), permi: ['community:anchorReview:examine'] }
      ],
      columns: [
        { title: '主播昵称', dataIndex: 'nick_name', align: 'left', width: '' },
        { title: '手机号', dataIndex: 'mobile', align: 'left', width: '' },
        { title: '用户类型', dataIndex: 'user_type_desc', align: 'left', width: '' },
        { title: '姓名', dataIndex: 'true_name', align: 'left', width: '' },
        { title: '提交时间', dataIndex: 'create_time', align: 'left', width: '' },
        { title: '审核状态', dataIndex: 'check_status_txt', align: 'left', width: '' },
        { title: '审核人', dataIndex: 'check_user', align: 'left', width: '' },
        { title: '审核时间', dataIndex: 'check_time', align: 'left', width: '' },
        { title: '操作', dataIndex: 'action', align: 'left', width: '', scopedSlots: {customRender: 'action_t'} }
      ],
      dataSource: [],
      searchParams: {
        keywords: undefined,
        user_type: undefined,
        status: undefined
      },
      listApi: {
        url: '/live/applys', // live/applys
        resHandle: this.resHandle, // this.resHandle
        searchHandle: '' // searchHandle
      },
      addHandleParam: {
        route: 'anchorReviewDetail',
        title: '审核详情'
      }
    };
  },
  created () {
    this.getSelect();
  },
  methods: {
    getSelect () {
      this._get({
        url: '/live/anchors/selectlist'
      }).then(res => {
        this.searchList[1].options = res.data.user_type;
        this.searchList[2].options = res.data.check_status;
      });
    },
    resHandle (res) {
      return res;
    },
    searchHandle (selectData) {
      console.log('处理搜索数据: ', selectData);
      // return selectData;
    }
  }
};
</script>
